// takes a user object, returns a function that...
// takes an item with an `accessLevels` property
// returns true if user should see the item, false if not
const checkAccessLevel = user => item => {
  const levels = item.accessLevels

  if (window.SERVER_SIDE_RENDERING) {
    // On server, only return items that will ALWAYS be shown for any user
    return levels.loggedOut && levels.loggedIn && levels.subscribed
  } else {
    // On client, only return items appropriate for the user
    const userStatus = user && user.isSubscribed ? 'subscribed' : user ? 'loggedIn' : 'loggedOut'
    return levels && levels[userStatus]
  }
}

export default checkAccessLevel
